import {DEFAULT_NOTIFICATIONS_LIMIT, IEmployeeNotification} from "@source/api/models/notificationModels";
import {makeAutoObservable} from "mobx";

class NotificationsStore {
  notifications: IEmployeeNotification[] = [];
  unreadCount = 0;
  hasMore = true;
  listOpen = false;
  unreadPromptOpen = false;
  unreadPromptDismissed = false;

  constructor() {
    makeAutoObservable(this);
  }

  setUnreadCount(count: number) {
    this.unreadCount = count;
  }

  showUnreadPrompt() {
    if (this.unreadCount > 0 && !this.unreadPromptDismissed && !this.listOpen) {
      this.unreadPromptOpen = true;
    }
  }

  setNotifications(notifications: IEmployeeNotification[]) {
    this.notifications = notifications;
    this.hasMore = notifications.length === DEFAULT_NOTIFICATIONS_LIMIT;
  }

  addNotifications(notifications: IEmployeeNotification[]) {
    const existingIds = new Set(this.notifications.map((notification) => notification._id));
    const nextNotifications = notifications.filter((notification) => !existingIds.has(notification._id));
    this.notifications = [...this.notifications, ...nextNotifications];
    this.hasMore = notifications.length === DEFAULT_NOTIFICATIONS_LIMIT;
  }

  openList() {
    this.unreadPromptOpen = false;
    this.unreadPromptDismissed = true;
    this.listOpen = true;
  }

  closeList() {
    this.listOpen = false;
    this.notifications = [];
    this.hasMore = true;
  }

  dismissUnreadPrompt() {
    this.unreadPromptOpen = false;
    this.unreadPromptDismissed = true;
  }

  resetSession() {
    this.notifications = [];
    this.unreadCount = 0;
    this.hasMore = true;
    this.listOpen = false;
    this.unreadPromptOpen = false;
    this.unreadPromptDismissed = false;
  }
}

export default new NotificationsStore();
